import values from 'lodash/values';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { CustomComponent, IProductTypeVariant } from '@cakeiteasy/web-utils';
import { calcCountForProductsGroup } from '../../cake-builder.helper';

@Component({
  standalone: false,
  selector: 'cake-multiple-variants-section',
  templateUrl: './cake-multiple-variants-section.component.html',
  styleUrls: ['./cake-multiple-variants-section.component.scss']
})
export class CakeMultipleVariantsSectionComponent extends CustomComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() active: boolean;
  @Input() variants: IProductTypeVariant[];
  @Input() countPerVariantMap: { [id: number]: number };
  @Input() step: number;
  @Input() maxQuantity = null;
  @Input() minCountPerProduct = null;
  @Input() currency = 'kr';
  @Input() discount: number;

  @Output() onSelect = new EventEmitter<{ variant: any; count: number }>();

  public disablePlus = false;

  constructor() {
    super();
  }

  ngOnInit() {
    this.checkPlusBtn(this.getVariantsCount());
  }

  public calcProductCountWrapper(productCount: number): (shiftCount: number, isManual?: boolean) => number {
    return (shiftCount: number, isManual = false) => {
      return calcCountForProductsGroup({
        productCount,
        shiftCount,
        groupCount: this.getVariantsCount(),
        maxQuantity: this.maxQuantity,
        minQuantity: this.minCountPerProduct,
        isManual,
      });
    };
  }

  public countUpdated(variant: IProductTypeVariant, productCount: number) {
    this._updateCountPerVariantMap(variant.id, productCount);
    this.checkPlusBtn(this.getVariantsCount());
    this.onSelect.emit({ variant, count: productCount });
  }

  public checkPlusBtn(groupCount: number): void {
    this.disablePlus = this.maxQuantity !== null && this.maxQuantity <= groupCount;
  }

  public getVariantsCount(): number {
    return values(this.countPerVariantMap).reduce((acc, val) => acc + val, 0);
  }

  private _updateCountPerVariantMap(variantId: number, count: number) {
    this.countPerVariantMap = { ...this.countPerVariantMap, [variantId]: count };
  }
}
